/**
 * This reducer is to support all custom features store in CT which are tailored for specific client and
 * available only fot that particular client.
 */
import { handleActions } from 'redux-actions';
import { FETCH_DOWNLOAD_VIDEO_SUCCESS } from 'common/actions';

const initialState = {
  downloadVideo: null,
};

export const customReducer = handleActions(
  {
    [FETCH_DOWNLOAD_VIDEO_SUCCESS]: (prevState, { payload: { video } }) => {
      return {
        ...prevState,
        downloadVideo: video,
      };
    },
  },
  initialState
);
